if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target
            .closest('.parent-display')
            ?.querySelector('.show-more-item');
          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains('hidden') &&
            nextElementToFocus.querySelector('input')
          ) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        // Try to find the expected structure first
        const showMoreElement = event.target.closest('[id^="Show-More-"]');
        if (!showMoreElement) return;

        let parentDisplay = showMoreElement.closest('.parent-display');

        // If parent-display doesn't exist, find the closest container that has show-more-item elements
        if (!parentDisplay) {
          // Look for a parent that contains show-more-item elements
          let currentElement = showMoreElement.parentElement;
          while (
            currentElement &&
            !currentElement.querySelector('.show-more-item')
          ) {
            currentElement = currentElement.parentElement;
          }
          parentDisplay = currentElement;
        }

        if (!parentDisplay) return;

        // Toggle label text visibility
        this.querySelectorAll('.label-text').forEach((element) =>
          element.classList.toggle('hidden'),
        );

        // Toggle show-more-item elements
        parentDisplay
          .querySelectorAll('.show-more-item')
          .forEach((item) => item.classList.toggle('hidden'));

        // Hide the button if there's no "show less" functionality
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    },
  );
}
